//
// Copyright (c) 2011-2025 by Curalate, Inc.
//

import { HashtagsByAccountData } from '@hashtags/queries/hashtagsQueries';
import InstagramBusinessAccountId from '@models/InstagramBusinessAccountId';

/**
 * Finds an Instagram business account based on hashtag usage.
 */
export const findInstagramBusinessAccountForHashtagTracking = (
  hashtagsByAccount: HashtagsByAccountData[],
): InstagramBusinessAccountId | undefined => {
  if (!hashtagsByAccount.length) {
    return undefined;
  }
  // Sort accounts by ascending number of used hashtags
  // and return the account with the fewest hashtags
  return [...hashtagsByAccount].sort(
    (a, b) => a.usedHashtagCount - b.usedHashtagCount,
  )[0]?.businessAccountId;
};
